const CapitalizeFirstLetter = (receivedString) => {
    let string = (receivedString || "");
    return string.replace(/^./, (string[0] || "").toUpperCase());
}

export default CapitalizeFirstLetter;